import { SportUpcomingEventTransformed } from '../../hooks/SportUpcomingEventsProvider/types';

export const SportUpcomingEventImage = ({
  image,
}: {
  image: SportUpcomingEventTransformed['participants'][number]['image'];
}) => {
  if (!image) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M3 2v8c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V2H3z"
          fill="#ddd"
        />
      </svg>
    );
  }

  return <img src={image.url} alt={image.alt} />;
};
